"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overrideTypographyStyles = exports.mergeTypographyStyles = void 0;
const mergeTypographyStyles = (baseStyles, overrides) => {
    return Object.entries(baseStyles).reduce((updatedStyles, [styleKey, base]) => {
        const override = overrides[styleKey];
        return {
            ...updatedStyles,
            [styleKey]: override
                ? {
                    ...base,
                    ...override,
                }
                : base,
        };
    }, baseStyles);
};
exports.mergeTypographyStyles = mergeTypographyStyles;
const overrideTypographyStyles = (baseStyles, overrides) => {
    return Object.entries(baseStyles).reduce((updatedStyles, [styleKey, base]) => {
        return {
            ...updatedStyles,
            [styleKey]: {
                ...base,
                ...overrides,
            },
        };
    }, baseStyles);
};
exports.overrideTypographyStyles = overrideTypographyStyles;
//# sourceMappingURL=utils.js.map